import { css } from "@emotion/react";

export const form = css`
  width: 100%;
`;

export const signInWrapperWidth = css`
  max-width: max-content;
`;

export const buttonStyles = css`
  width: unset;
`;
